import type { LegendListRef } from "@legendapp/list/react";
import { useEffect, useRef, type RefObject } from "react";
import type { RemoteThreadDispatchSettings } from "./useRemoteThreadExecutionIntent";

export function useRemoteSubmissionReveal(
  threadKey: string,
  pendingMessageId: string | undefined,
  historyState: "loading" | "error" | "ready",
  listRef: RefObject<LegendListRef | null>,
  onExecutionIntent: (settings?: RemoteThreadDispatchSettings) => void,
) {
  const requestedThread = useRef<string | null>(null);
  useEffect(() => {
    if (
      requestedThread.current !== threadKey ||
      !pendingMessageId ||
      historyState !== "ready" ||
      !listRef.current
    )
      return;
    const frame = requestAnimationFrame(() => {
      if (!listRef.current) return;
      requestedThread.current = null;
      listRef.current.scrollToEnd({ animated: false });
    });
    return () => cancelAnimationFrame(frame);
  }, [threadKey, pendingMessageId, historyState, listRef]);

  return (settings?: RemoteThreadDispatchSettings) => {
    requestedThread.current = threadKey;
    onExecutionIntent(settings);
  };
}
